import { createFileRoute } from "@tanstack/react-router";
import { VendorsPage } from "@/features/vendors/vendors-page";

export const Route = createFileRoute("/app/w/$weddingId/vendors")({ component: VendorsPage });
